/**
 * Strip WordPress/RSS footer boilerplate from excerpt text.
 */
export function stripRssBoilerplate(text) {
  if (!text || typeof text !== 'string') return '';
  let t = text.replace(/\s+/g, ' ').trim();

  const cutPhrases = [
    /the post .+ appeared first on .+$/i,
    /this article appeared (?:first )?on .+$/i,
    /this post appeared (?:first )?on .+$/i,
    /appeared first on [^.]+\.?$/i,
    /read more at .+$/i,
    /continue reading .+$/i
  ];
  for (const re of cutPhrases) {
    const next = t.replace(re, '').trim();
    if (next.length < t.length) t = next;
  }

  const low = t.toLowerCase();
  const firstIdx = low.indexOf('appeared first on');
  if (firstIdx !== -1) {
    t = t.slice(0, firstIdx).trim();
    t = t.replace(/[.,;:\s]+$/, '').trim();
  }

  return t;
}

/**
 * Hostname for "Read on gearnews.com →" (no protocol).
 */
export function formatReadOnHostname(articleUrl) {
  if (!articleUrl || typeof articleUrl !== 'string') return '';
  try {
    const u = new URL(articleUrl);
    return u.hostname.replace(/^www\./i, '');
  } catch {
    return '';
  }
}

/** Visible excerpt length on the News page (full text remains in Firestore). */
const SUMMARY_DISPLAY_MAX = 200;

/**
 * Truncate cleaned summary for card display; returns { text, truncated }.
 */
export function truncateSummaryForDisplay(text, maxLen = SUMMARY_DISPLAY_MAX) {
  const t = typeof text === 'string' ? text.trim() : '';
  if (!t) return { text: '', truncated: false };
  if (t.length <= maxLen) return { text: t, truncated: false };
  const slice = t.slice(0, maxLen);
  const cut = slice.replace(/\s+\S*$/, '').trim() || slice;
  return { text: `${cut}…`, truncated: true };
}

/** Firestore Timestamp, ISO string, or Date → JS Date or null. */
export function newsArticleToJsDate(publishedAt) {
  if (!publishedAt) return null;
  try {
    const d =
      typeof publishedAt.toDate === 'function'
        ? publishedAt.toDate()
        : new Date(publishedAt);
    return isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
}

/** Short date for compact tiles, e.g. "Apr 8". */
export function formatNewsDateShort(publishedAt) {
  const d = newsArticleToJsDate(publishedAt);
  if (!d) return '';
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric'
  });
}
